import React, { FC } from 'react';
import Lottie from 'lottie-react-web';
import Paragraph from '@bitcoin-portal/bitcoincom-pkg-components/dist/Paragraph';

import Success from '../Success.json';
import {
  AnimationWrapper,
  CustomField,
  CustomLabel,
  CustomLink,
} from '../styled';
import Share from '../Share';

interface Props {
  txid: string;
  status: string;
}

const LoadingStatus: FC<Props & Queries.ThankYouCommonFragment> = ({
  txid,
  status,
  content,
  links,
}) => {
  return (
    <>
      <AnimationWrapper>
        <Lottie
          options={{
            animationData: Success,
            loop: false,
          }}
        />
      </AnimationWrapper>
      {txid && status && (
        <div style={{ textAlign: 'left' }}>
          <CustomLabel>{txid}</CustomLabel>
          <CustomField>{txid}</CustomField>
          <CustomLabel>{status}</CustomLabel>
          <CustomField>{status}</CustomField>
        </div>
      )}
      <Paragraph align="left">{content?.description}</Paragraph>
      <Paragraph align="left" style={{ fontWeight: 'bold' }}>
        {content?.checkYourEmail}
      </Paragraph>
      <Paragraph align="left" style={{ paddingBottom: '48px' }}>
        {content?.moreInfoSuccess}
        <CustomLink href={links?.faq?.url}>{links?.faq?.title}</CustomLink>
      </Paragraph>
      <Share />
    </>
  );
};

export default LoadingStatus;
